export default __webpack_public_path__ + "static/media/image49.d4421d6a.png";